var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import styled from "styled-components";
import ReactPhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Col } from "react-bootstrap";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import Validation, { ValidationInput } from "@irati/utils/validation";
import getCurrentLocale from "@irati/utils/lang/helpers/getCurrentLocale";
import { FormGroup } from "../Form";
import Label from "./styled/Label";
import InfoTooltip from "./utils/InfoTooltip";
import ErrorText from "../ErrorText";
import HintText from "../HintText";
import { guessCountryFromLocale } from "./helpers/phoneInput";
var StyledReactPhoneInput = styled(ReactPhoneInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  img {\n    vertical-align: initial;\n    margin-bottom: 2px;\n  }\n\n  .react-phone-number-input__icon {\n    border: 0;\n  }\n\n  margin-top: -10px;\n  .react-phone-number-input__input {\n    height: calc(0.6rem * 6);\n  }\n"], ["\n  img {\n    vertical-align: initial;\n    margin-bottom: 2px;\n  }\n\n  .react-phone-number-input__icon {\n    border: 0;\n  }\n\n  margin-top: -10px;\n  .react-phone-number-input__input {\n    height: calc(0.6rem * 6);\n  }\n"])));
var PhoneInput = /** @class */ (function (_super) {
    __extends(PhoneInput, _super);
    function PhoneInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validation = new ValidationInput(_this);
        _this.state = {
            blurred: false,
            value: ""
        };
        _this.handleChange = function (value) {
            _this.setState({ value: value, blurred: true });
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }
    PhoneInput.getDerivedStateFromProps = function (nextProps) {
        if (nextProps.value) {
            return { value: nextProps.value };
        }
        return {};
    };
    PhoneInput.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.blurred) {
            this.validation.update(prevProps, prevState);
        }
    };
    PhoneInput.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    PhoneInput.prototype.render = function () {
        var _a = this.props, hint = _a.hint, hideLabel = _a.hideLabel, className = _a.className, formatMessage = _a.formatMessage, placeholder = _a.placeholder, tooltip = _a.tooltip, tooltipPosition = _a.tooltipPosition, customTooltip = _a.customTooltip, countries = _a.countries;
        var resolvedPlaceholder = placeholder ? formatMessage({ id: placeholder }) : "";
        var resolvedCountryCode = this.props.country || guessCountryFromLocale(getCurrentLocale());
        var _b = this.state, errorMsg = _b.errorMsg, error = _b.error;
        var idNameSpace = id("phoneInput", this.props);
        var ids = {
            label: id("label", idNameSpace),
            input: id("input", idNameSpace),
            error: id("copy-error", idNameSpace),
            hint: id("copy-hint", idNameSpace)
        };
        return (React.createElement(FormGroup, { className: className, validationState: errorMsg ? "error" : undefined },
            React.createElement(Col, { hidden: hideLabel, xs: tooltip ? 10 : 12 },
                React.createElement(Label, { id: ids.label, error: errorMsg, htmlFor: ids.input }, getResolvedMessage(this, "label"))),
            tooltip && (React.createElement(Col, { xs: 2 },
                React.createElement(InfoTooltip, { tooltip: tooltip, position: tooltipPosition, customIcon: customTooltip }))),
            React.createElement(Col, { xs: 12 },
                React.createElement(StyledReactPhoneInput, { id: ids.input, country: resolvedCountryCode, international: !countries, countries: countries, placeholder: resolvedPlaceholder, value: this.state.value, onChange: this.handleChange })),
            (errorMsg || error) && (React.createElement(ErrorText, { id: ids.error, small: true }, getResolvedMessage(this, "errorMsg", this.state) || getResolvedMessage(this, "error"))),
            hint && (React.createElement("div", null,
                React.createElement(HintText, { id: ids.hint, small: true }, getResolvedMessage(this, "hint"))))));
    };
    return PhoneInput;
}(PureComponent));
function ValidationHoc(props) {
    var p = __assign({}, props);
    if (p.required) {
        // We do not want to support stupid validation rules on phone numbers, simply required or not.
        p.validation = Validation.string(props.formatMessage({ id: "platform.mfa.phoneNumber.errors.isRequired" }));
    }
    return React.createElement(PhoneInput, __assign({}, props));
}
export default injectIntl(ValidationHoc);
var templateObject_1;
